module.exports = __webpack_public_path__ + "img/no-data-icon.67fa2f80.svg";